<template>
  <default-layout>
    <back-button
      v-if="showBackButton && $vuetify.breakpoint.mdAndUp"
      :move-back="false"
      @click="goBack"
    />
    <vue-friendly-iframe
      :src="iframeSrc"
      class="panorama3"
      frameborder="0"
      gesture="media"
      allow="encrypted-media"
      allowfullscreen="allowfullscreen"/>
  </default-layout>
</template>

<script>
import store from '@/store';
import { mapActions, mapGetters } from 'vuex';
import DefaultLayout from '@/layouts/Default.vue';
import VueFriendlyIframe from 'vue-friendly-iframe';
import BackButton from '@/components/BackButton';

export default {
  name: 'PanoramaSingle',
  components: {
    BackButton,
    DefaultLayout,
    'vue-friendly-iframe': VueFriendlyIframe,
  },
  beforeMount() {
    if (!store.state.panoramas.panoramas.length) {
      store.dispatch('panoramas/load', { order: this.$route.params.order });
    }
  },
  computed: {
    ...mapGetters('panoramas', ['panoramas']),
    iframeSrc() {
      return this.$route.query.iframeSrc;
    },
    showBackButton() {
      return this.$routerHistory.hasPrevious();
    },
  },
  methods: {
    ...mapActions('panoramas', ['getUnitByPanoramaId']),
    goBack() {
      this.$router.push({ path: this.$routerHistory.previous().path });
    },
  },
};
</script>

<style>
.panorama3 {
  position: fixed;
  top: var(--app-bar-height);
  left: 0;
  right: 0;
  bottom: 0;
}

.panorama3 iframe {
  width: 100%;
  height: 100%;
}

.fab-back-button {
  position: fixed;
  z-index: 20;

  top: var(--app-main-top);
  left: 15px;
  border-radius: 28px;
  width: 56px;
  height: 56px;
}
</style>
